import {GetRoundStepApiResponse} from '@dms/api/shared';

import {Nullish} from 'shared/web';

export const getRoundStepOptions = (roundSteps: GetRoundStepApiResponse | Nullish) =>
  roundSteps?.map((roundStep) => ({value: roundStep.key, label: roundStep.value})) ?? [];
